import { render, staticRenderFns } from "./ConfirmInAppPurchase.vue?vue&type=template&id=b4d8bc62&scoped=true"
import script from "./ConfirmInAppPurchase.vue?vue&type=script&lang=ts&scoped=true"
export * from "./ConfirmInAppPurchase.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./ConfirmInAppPurchase.vue?vue&type=style&index=0&id=b4d8bc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8bc62",
  null
  
)

export default component.exports